export default __webpack_public_path__ + "static/media/Landing icon (mobile).82fc7614.svg";